let child = null
let interval = null
let interval2 = null
let loginURL = 'https://app.nixplay.com/shop/login'
let subscriptionLoginURL = 'https://app.nixplay.com/shop-subscription/login'
// let loginURL = 'http://localhost:7000/shop/login'
let signupURL = 'https://app.nixplay.com/shop/signup'
// let signupURL = 'http://localhost:7000/shop/signup'
// let subscriptionPage = 'https://app.nixplay.com/shop-subscription/signup'
// let subscriptionPage = 'http://localhost:7000/shop-subscription/signup'
let logoutURL = 'https://api.nixplay.com/sign_out/'

const match = window.location.hostname.match(/[^\w](qa)[^\w]/)

	if (match) {
		loginURL = `https://app.${match[1]}.nixplay.com/shop/login`
		signupURL = `https://app.${match[1]}.nixplay.com/shop/signup`
		logoutURL = `https://api.${match[1]}.nixplay.com/sign_out/`
		subscriptionLoginURL = `https://app.${match[1]}.nixplay.com/shop-subscription/login`
	}

if (typeof receiveMessage === 'undefined') {
	receiveMessage = (event) => {
		const getCookie = (cname) => {
			let name = cname + "=";
			let decodedCookie = decodeURIComponent(document.cookie);
			let ca = decodedCookie.split(';');
			for(let i = 0; i <ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}

		if (typeof event.data.startsWith === 'function' && event.data.startsWith('loginCompleted')) {
			child.close()
			const redirectURL = getCookie('nixplay_login_redirect_url')
			if (redirectURL) {
				const now = new Date()
				document.cookie = `nixplay_login_redirect_url=n ; expires=${now.toUTCString()}'path=/`
				window.location.href = redirectURL
			} else {
				window.location.replace(window.location.href);
				window.location.reload();
			}
		}
	}
}

window.addEventListener('message', receiveMessage, false)

const gotoLogin = (returnUrl = '') => {
	let url = `${subscriptionLoginURL}`
	if (returnUrl) {
		url += `?returnUrl=${returnUrl}`
	}
	window.location.href = url
}

const setLoginRedirectURL = (url) => {
	const now = new Date()
	const nowPlus10m = new Date(now.getTime() + (10 * 60 * 1000))
	document.cookie = `nixplay_login_redirect_url=${url} ; expires=${nowPlus10m.toUTCString()}'path=/`
}

const openPopup = (url = loginURL) => {
	if (child) {
		child.focus()
	}
	const w = 340
	const h = 450
	const l = (window.innerWidth / 2) + window.screenX - (w / 2)
	const t = (window.innerHeight / 2) + window.screenY - (h / 2)
	child = window.open(url, 'child',
		`titlebar=no,status=no,height=${h},width=${w},resizable=yes,left=${l},top=${t},screenX=${l},screenY=${t},toolbar=no,menubar=no,scrollbars=no,location=no,directories=no`)
	if (child) {
		child.opener = null
	}

	// cleanup when child window close
	if (interval) {
		clearInterval(interval)
	}
	interval = setInterval(() => {
		if (child && child.closed) {
			child = null
			clearInterval(interval)
			clearInterval(interval2)
		}
	}, 300)

	// establish communication with child window
	if (interval2) {
		clearInterval(interval2)
	}
	interval2 = setInterval(() => {
		try {
			child.postMessage('login')
		} catch {

		}
	}, 50)
}

const openTab = (url = loginURL) => {
	child = window.open(url, '_blank')
	if (child) {
		child.opener = null
	}
}

const openLogin = (query = '') => {
	openPopup(`${loginURL}${query}`)
}

const openSignup = (query = '?signup') => {
	openPopup(`${signupURL}${query}`)
}

const openLogout = () => {
	const iframeLogOut = document.createElement('iframe');
	iframeLogOut.src = logoutURL;
	iframeLogOut.setAttribute("id", "nixplayLogoutIframe");
	document.body.appendChild(iframeLogOut);
	setTimeout(() => document.getElementById('nixplayLogoutIframe').remove(), 10000)
}
